import { URL_LABEL } from "../../../index.content";

const termsOfUse = ({ language, isSavedUser }) => {
  return {
    title: "Terms of Use",
    url: `/terms-of-use?${URL_LABEL}`,
    target: false,
    ref: false,
    isLink: true,
    action: "TermsOfUse",
  };
};

export default termsOfUse;
